import React, { Component, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import {
  Form,
  FormHeader,
  Button,
  ResultsCounter,
  Actions,
  MoreActions,
  ButtonSecondary,
  Table,
  CheckboxElement,
  Link
} from "cw-styleguide-react";
import { STEP_SESSION_DETAILS } from "../../../../constants";
import withAssets from "../../../../components/hoc/withAssets";
import ErrorNavigation from '../../../../components/ErrorNavigation';

class SessionsViewStep extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedSessions: new Set()
    };

    this.handleSelectSession = this.handleSelectSession.bind(this);
    this.handleRemoveSessions = this.handleRemoveSessions.bind(this);
  }

  componentDidMount() {
    if (this.props.sessionId) {
      this.props.handleSet({
        sessionId: '',
        startDate: '',
        startDetails_en: '',
        startDetails_cy: '',
        daysTimes_en: '',
        daysTimes_cy: '',
        studyMethodType: new Set(),
        studyMethodHours: new Set(),
        studyMethodTimes: new Set(),
        contactId: '',
        contactLabel: '',
        contacts: [],
        venueId: '',
        venueLabel: '',
        venueContactId: '',
        venueContactLabel: '',
        venues: []
      });
    }
  }

  handleSelectSession(e) {
    const selectedSessions = this.state.selectedSessions;
    const selectedSessionId = e.target.value;

    if (selectedSessions.has(selectedSessionId)) {
      selectedSessions.delete(selectedSessionId);
    } else {
      selectedSessions.add(selectedSessionId);
    }

    this.setState(selectedSessions);
  }

  handleRemoveSessions(e) {
    e.preventDefault();

    const selectedSessions = this.state.selectedSessions;

    let sessions = this.props.sessions;

    sessions = sessions.filter(session => !selectedSessions.has(session.uuid));

    sessions = sessions.map((session, index) => {
      session.id = index + 1;

      return session;
    });

    this.props.handleSet('sessions', sessions);

    selectedSessions.clear();

    this.setState(selectedSessions);
  }

  render() {
    return (
      <Form multi={true}>
        <ErrorNavigation field={this.props.errorActiveField} handleClearActiveErrors={this.props.handleClearActiveErrors} />
        <FormHeader title={this.props.t('local:view.courses.create.tabs.sessions.step.view.title')}
          introduction={this.props.t('local:view.courses.create.tabs.sessions.step.view.introduction')} />

        <div id={'sessions'}>
          <ResultsCounter count={this.props.sessions.length}>
            <span>{this.props.t('local:view.courses.create.tabs.sessions.step.view.table.entity')}</span>
            <Actions>
              <MoreActions>
                <ButtonSecondary classes={['button--large']} onClick={this.handleRemoveSessions}>
                  {this.props.t('local:view.courses.create.tabs.sessions.step.view.table.control.remove')}
                </ButtonSecondary>
              </MoreActions>
              <Button classes={['button--large']} onClick={(e) => this.props.handleSetStep(e, STEP_SESSION_DETAILS)}>
                {this.props.t('local:view.courses.create.tabs.sessions.step.view.table.control.create')}
              </Button>
            </Actions>
          </ResultsCounter>
          <Table headers={[
            this.props.t('local:view.courses.create.tabs.sessions.step.view.table.header.select'),
            this.props.t('local:view.courses.create.tabs.sessions.step.view.table.header.session'),
            this.props.t('local:view.courses.create.tabs.sessions.step.view.table.header.startDate')]}
            rows={this.props.sessions.map((session, index) => {
              return ([
                <CheckboxElement checked={this.state.selectedSessions.has(session.uuid)} value={session.uuid} onChange={this.handleSelectSession} />,
                <Link to={'#'} target={'_blank'} data-id={session.uuid} onClick={(e) => {
                  this.props.handleLoadSession(e, session);
                  this.props.handleSetStep(e, STEP_SESSION_DETAILS);
                }}>{this.props.t('local:view.courses.create.tabs.sessions.step.view.table.header.session')} {session.id}</Link>,
                session.startDate && moment(session.startDate).isValid() ? moment(session.startDate).format('DD/MM/YYYY') : this.props.t('misc.none')
              ]);
            })} />
        </div>
      </Form>
    );
  }

}

export default withAssets(withTranslation('local')(SessionsViewStep));
